/* @flow */
import * as React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import ConfirmDialog from 'components/ConfirmDialog.jsx';
import ErrorReporter from 'app/components/ErrorReporter.jsx';
import EventTracking from 'lib/EventTracking';
import LoadingModal from 'components/LoadingModal.jsx';

import type { MessageFilterType } from 'reducers/roleBasedMessagingSearch';

type Props = {
  orgUuid: ?string,
  orgName: ?string,
  onConfirm: Function,
  onRequestHide: () => void,
  filters: MessageFilterType[],
  data: ReactApolloData<SendToDistrictConfirmDialogQuery>,
};

class SendToDistrictConfirmDialog extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('announcements.composer.confirm_send.view', {
      organization_uuid: this.props.orgUuid,
    });
  }

  render() {
    const { data, onConfirm, onRequestHide, orgName, orgUuid } = this.props;

    if (!orgUuid) {
      return (
        <ErrorReporter error="Tried to render SendToDistrictConfirmDialog without an orgUuid" />
      );
    }

    if (!orgName) {
      return (
        <ErrorReporter error="Tried to render SendToDistrictConfirmDialog without an orgName" />
      );
    }

    if (data && data.loading) {
      return <LoadingModal />;
    }

    if (data && data.countRecipients) {
      const secondaryText = `This announcement will be sent to ${
        data.countRecipients.count
      } people in ${orgName}`;
      return (
        <ConfirmDialog
          title={<span>{secondaryText}</span>}
          onConfirm={onConfirm}
          onRequestHide={onRequestHide}
          actionButtonText="Send"
          cancelButtonText="Cancel"
          cancelEventKey="announcements.composer.confirm_send.cancel.click"
          cancelEventProperties={{
            organization_uuid: orgUuid,
          }}
        />
      );
    }

    return null;
  }
}

const withData = graphql(
  gql`
    query SendToDistrictConfirmDialog($input: RecipientInput!) {
      countRecipients(input: $input) {
        count
      }
    }
  `,
  {
    skip: ({ orgUuid }) => !orgUuid,
    options: ({ orgUuid, filters }) => {
      const roles = filters
        ? filters.filter(filter => filter.type === 'roles').map(filter => filter.value.id)
        : [];
      const filterArray = roles.length ? [{ roles }] : [];
      return {
        variables: { input: { type: 'organization', uuid: orgUuid, filters: filterArray } },
      };
    },
  }
);

export { SendToDistrictConfirmDialog };

export default withData(SendToDistrictConfirmDialog);
